import { Box, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { RPMTableHeaderCell } from "../../shared/table/RPMTableHeaderCell";
import { RPMTableHeaderRow } from "../../shared/table/RPMTableHeaderRow";
import { Win, Win_SampleMarketDeduction } from "../../../interfaces/dtos/win";
import { RPMTable } from "../../shared/table/RPMTable";

interface ScheduleWinMarketDeductionsProps {
    eventWin?: Win;
}

export const ScheduleWinMarketDeductions = ({
    eventWin
}: ScheduleWinMarketDeductionsProps) => {

    if (!eventWin) { return <></> }

    const getMarketDeductions = (marketType: string) => {
        return eventWin.sampleMarketDeductions ?
            eventWin.sampleMarketDeductions.filter((md) => md.marketType === marketType) :
            [];
    }

    const mdEP = getMarketDeductions('EP');
    const mdBP = getMarketDeductions('BP');
    const rowSize = mdEP.length > mdBP.length ? mdEP.length : mdBP.length;

    const getMDDesc = (md: Win_SampleMarketDeduction[], index: number) => {
        return md.length >= index + 1 ?
            md[index].marketDesc :
            ''
    }

    return (
        <Box sx={{ paddingTop: '20px', display: 'flex' }}>
            <RPMTable
                containerProps={{ sx: { width: 'auto' } }}
                tableProps={{ id: 'table-marketdeductions', sx: { width: 'auto' } }}
            >
                <TableHead>
                    <RPMTableHeaderRow>
                        <RPMTableHeaderCell>EP Market Deductions</RPMTableHeaderCell>
                        <RPMTableHeaderCell>BP Market Deductions</RPMTableHeaderCell>
                    </RPMTableHeaderRow>
                </TableHead>
                <TableBody>
                    {new Array(rowSize).fill(0).map((_, i) => (
                        <TableRow key={i}>
                            <TableCell>{getMDDesc(mdEP, i)}</TableCell>
                            <TableCell>{getMDDesc(mdBP, i)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </RPMTable>
        </Box>
    )
}
